import { CheckCircle2 } from 'lucide-react';
import ModalShell from '../../components/ui/ModalShell';
import { OK, Tlacitko } from './ui';

/**
 * „Proběhlo předání v pořádku?" (2026-10-23) — u objednávky zaplacené online.
 *
 * Doručení bylo jen jedno ťuknutí a šlo ho omylem odklepnout ještě v autě.
 * U hotovosti a karty je potvrzením samotná platba, tady chybělo. Ptáme se
 * jednou větou a „Ano, předáno" je velké, ať to rozvozce u dveří nezdrží.
 */
export default function PredaniModal({ zastavka, onConfirm, onClose, isDark }) {
    if (!zastavka) return null;

    return (
        <ModalShell open onClose={onClose} isDark={isDark} nadpis="Předání" ikona={CheckCircle2} barva={OK}
            paticka={
                <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 2fr)', gap: 10 }}>
                    <Tlacitko onClick={onClose}>Ještě ne</Tlacitko>
                    <Tlacitko plne barva={OK} onClick={onConfirm}>
                        <CheckCircle2 size={20} /> Ano, předáno
                    </Tlacitko>
                </div>
            }>
            <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 10 }}>
                <div style={{ fontSize: 20, fontWeight: 900 }}>Proběhlo předání v pořádku?</div>
                <div style={{ fontSize: 15, lineHeight: 1.45, color: 'var(--text-secondary)' }}>
                    {zastavka.jmeno || 'Zákazník'} · {zastavka.adresa || '—'}
                    <br />Zaplaceno online — nic se nevybírá.
                </div>
            </div>
        </ModalShell>
    );
}
